
    <svg:path *ngIf="active" [attr.d]="path" stroke-linecap="round" stroke-width="3"
              [attr.stroke-dasharray]="complete ? '0, 0' : '10, 10'"
              stroke="#50AE01"/>
  


// WEBPACK FOOTER //
// ./src/library/graph/edge/workflow-graph-draw-edge.component.ts.WorkflowGraphDrawEdgeComponent.html